import React, { FC } from 'react';
import styled, { css } from 'styled-components';

const StyledMarkerWrap = styled.div`
    ${({ theme, color }) => css`
        position: relative;
        width: 26px;
        .count-label {
            position: absolute;
            top: 4px;
            left: 50%;
            transform: translateX(-50%);
            font-size: 14px;
            color: ${color};
            font-family: ${theme.typography.fontFamily};
        }
    `}
`;
const StyledMarker = styled.svg`
    text {
        text-align: center;
        width: 20px;
    }
`;
interface SmallMarkerProps {
    count: number;
    color?: string;
}

const SmallMarker: FC<SmallMarkerProps> = ({ count, color = '#009FE3' }) => (
    <StyledMarkerWrap color={color}>
        <span className="count-label">{count}</span>
        <StyledMarker
            viewBox="0 0 26 34"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <g id="Symbols" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
                <g id="Icon---Map-Pin-Garden-Centre---Sml" transform="translate(-7.000000, -3.000000)">
                    <g id="pin-blue" transform="translate(7.000000, 3.000000)">
                        <path
                            d="M11.6639792,33.3140153 C1.82609375,19.3262726 0,17.8907027 0,12.7499969 C0,5.70834626 5.82027604,0 13,0 C20.179724,0 26,5.70834626 26,12.7499969 C26,17.8907027 24.1739062,19.3262726 14.3360208,33.3140153 C13.6904219,34.2286948 12.3095104,34.2286284 11.6639792,33.3140153 Z"
                            id="Shape"
                            fill={color}
                        />
                        <circle id="Oval" fill="#FFFFFF" cx={13} cy={13} r={9} />
                    </g>
                </g>
            </g>
        </StyledMarker>
    </StyledMarkerWrap>
);

export default SmallMarker;
